export default __webpack_public_path__ + "static/media/1title.c987d64a.jpg";